import { ArrayUtils } from "../../../../services/ArrayUtils";
import { AddStatusMessage } from "../../StatusBar/StatusBar";
import { EStatusMessageType } from "../../StatusBar/StatusMessageType/StatusMessageType";

export function ShowEncouragementStatusMessage() {
    const randomEncouragement = ArrayUtils.GetRandomElement([
        `Good job!`,
        `Awesome!`,
        `Great work!`,
    ]);

    AddStatusMessage(randomEncouragement, EStatusMessageType.success);
}
